"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueFileIdentifierFromS3key = void 0;
const fileNameParser_1 = require("./fileNameParser");
const uniqueFileIdentifierFromS3key = (s3Key) => {
    const result = fileNameParser_1.FILE_S3_KEY_REGEXP.exec(s3Key);
    return result ? result[1] : '';
};
exports.uniqueFileIdentifierFromS3key = uniqueFileIdentifierFromS3key;
